import React from "react";

// Asset URLs from Figma

const NewLogo26 = () => {
  const width = window.innerWidth;

  return (
    <div className="mx-auto flex w-full flex-col items-center gap-2 md:max-w-[358px]">
      <div className="flex w-fit items-center gap-2 rounded-md bg-white/10 p-2">
        <img
          src="https://img.learntube.ai/public-assets/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449"
          loading="eager"
          alt=""
          width={24}
          height={24}
          className="h-6 w-6"
        />
        <p className="text-xs font-medium">LearnTube.ai</p>
      </div>
      <div
        className={`w-[calc(100%+2rem)] justify-center ${
          width < 360 ? "gap-4" : "gap-6"
        } flex px-4 pt-2 pb-2.5 shadow-[0_4px_8px_-4px_rgba(0,0,0,0.5)] sm:rounded`}
        style={{
          backgroundImage:
            "linear-gradient(to top, rgba(64, 106, 255, 0.1) 25%, rgba(2, 36, 57, 0.1) 100%)",
        }}
      >
        <div className="flex flex-1 flex-col items-center gap-1">
          <h4 className="text-[0.5625rem] leading-none text-white/50">
            Recognised by
          </h4>
          <img
            src="https://img.learntube.ai/public-assets/company-logos/Logosvg.webp"
            width={69}
            height={14}
            className="h-[0.875rem] w-auto flex-shrink-0"
            alt=""
          />
        </div>
        <div className="w-[1px] self-stretch bg-white/20" />
        <div className="flex flex-1 flex-col items-center gap-1">
          <h4 className="text-[0.5625rem] leading-none text-white/50">
            backed by
          </h4>
          <img
            src="https://img.learntube.ai/public-assets/company-logos/Frame%20427323186.webp"
            width={69}
            height={14}
            className="h-[0.875rem] w-auto flex-shrink-0"
            alt=""
          />
        </div>
        <div className="w-[1px] self-stretch bg-white/20" />
        <div className="flex flex-1 items-center gap-1">
          <img
            src="https://img.learntube.ai/public-assets/company-logos/Frame%20427323188.webp"
            width={85}
            height={23}
            className="h-[1.4375rem] w-auto flex-shrink-0"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default NewLogo26;
